import * as stringSimilarity from "string-similarity";

export function checkSimilarity(
  word: string,
  list: string[]
): stringSimilarity.BestMatch {
  const matches = stringSimilarity.findBestMatch(word, list);
  return matches;
}
